import type { ReactNode } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { useT } from './i18n';
import { SignInScreen } from './screens/SignInScreen';
import { appRoutes } from './routes';

// The authenticated app is a react-router SPA. The route tree lives in
// routes.tsx (modular, data-driven) so page tasks 16.3-16.7 add routes there
// without touching this shell. The router is created once at module scope so it
// is not rebuilt on every render.
const router = createBrowserRouter(appRoutes);

// App shell: renders the sign-in screen when unauthenticated and the routed
// application when signed in (Req 1.1, 1.2). The signed-in gate is driven
// entirely by the Cognito session.
export function App(): ReactNode {
  const auth = useAuth();
  const { t } = useT();

  if (auth.isLoading) {
    return (
      <main className="app-loading">
        <p>{t('app.loading')}</p>
      </main>
    );
  }

  return auth.isAuthenticated ? <RouterProvider router={router} /> : <SignInScreen />;
}
